import { createReducer, on } from '@ngrx/store';
import { StockItem } from '../../core/models';
import { AuthActions } from '../auth/auth.actions';
import { StockActions } from './stock.actions';

export interface StockState {
  items: StockItem[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialStockState: StockState = {
  items: [],
  loading: false,
  loaded: false,
  error: null,
};

export const stockReducer = createReducer(
  initialStockState,

  on(StockActions.loadStock, (state) => ({ ...state, loading: true, error: null })),
  on(StockActions.loadStockSuccess, (state, { items }) => ({
    ...state,
    items,
    loading: false,
    loaded: true,
  })),
  on(StockActions.loadStockFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.logout, () => initialStockState),
);
